import {  gql } from '@apollo/client';



export const ADD_WALLPAPER = gql`
   mutation ($image:Upload!,$title:String!,$category:String!,$description:String!) {
  createWallpaper(image: $image, title: $title,category:$category, description: $description) {
    id
    image
    title
    category
    description
    username
  }
} 
`;

export const UPDATE_WALLPAPER = gql`
   mutation ($wallpaperId: ID!, $image: Upload, $title: String, $category: String, $description: String) {
  updateWallpaper(wallpaperId: $wallpaperId, image: $image, title: $title, category: $category, description: $description) {
    id
    image
    title
    category
    description
    username
    
  }
}
 `;


export const DELETE_WALLPAPER= gql`
mutation ($wallpaperId: ID!) {
deleteWallpaper(wallpaperId: $wallpaperId) {
  id
  image
  title
  category
  description
  username
}
}
`;



export  const LOGIN_USER = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      id
      email
      username
      token
    }
  }
`;



export const REGISTER_USER = gql`
  mutation register(
    $username: String!
    $email: String!
    $password: String!
  ) {
    register(
      registerInput: {
        username: $username
        email: $email
        password: $password
      }
    ) {
      id
      email
      username
      token
    }
  }
`;